import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb40" }
const _hoisted_2 = { class: "mb40" }
const _hoisted_3 = { class: "mb40" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoBack = _resolveComponent("GoBack")!
  const _component_company_block = _resolveComponent("company-block")!
  const _component_CStep1 = _resolveComponent("CStep1")!
  const _component_CSignatureType = _resolveComponent("CSignatureType")!
  const _component_CSignatore = _resolveComponent("CSignatore")!
  const _component_COptions = _resolveComponent("COptions")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_CertificateList = _resolveComponent("CertificateList")!
  const _component_PopUp = _resolveComponent("PopUp")!
  const _component_MessagePopup = _resolveComponent("MessagePopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_GoBack)
    ]),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_company_block, { company: _ctx.company }, null, 8, ["company"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Добавление документов", -1)),
      _createVNode(_component_CStep1, {
        modelValue: _ctx.DocForm_.files,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.DocForm_.files) = $event))
      }, null, 8, ["modelValue"]),
      (_ctx.DocForm_.files?.length)
        ? (_openBlock(), _createBlock(_component_CSignatureType, {
            key: 0,
            modelValue: _ctx.DocForm_.signatureType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.DocForm_.signatureType) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.DocForm_.files?.length)
        ? (_openBlock(), _createBlock(_component_CSignatore, {
            key: 1,
            modelValue: _ctx.DocForm_.contact,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.DocForm_.contact) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.DocForm_.files?.length)
        ? (_openBlock(), _createBlock(_component_COptions, {
            key: 2,
            form: _ctx.DocForm_,
            onUpdate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAgreement($event))),
            onUpdateProp: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateForm($event))),
            ref: "OptionsComponent"
          }, null, 8, ["form"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.DocForm_.files?.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createVNode(_component_PButton, {
            title: "Подписать и отправить",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.send()))
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PopUp, {
      modalOpen: _ctx.kepModalOpen,
      onClose: _ctx.onKepCancel,
      ref: "kepPopup"
    }, {
      default: _withCtx(() => [
        _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Подписание КЭП", -1)),
        (_ctx.kepModalContent && !_ctx.certificates.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: _ctx.kepModalContent
            }, null, 8, _hoisted_5))
          : (_ctx.certificates.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[8] || (_cache[8] = _createElementVNode("h6", null, "Выберите сертификат", -1)),
                _createVNode(_component_CertificateList, {
                  certificates: _ctx.certificates,
                  selectedThumb: _ctx.selectedCertificate,
                  onSelect: _ctx.handleCertificateSelect
                }, null, 8, ["certificates", "selectedThumb", "onSelect"])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modalOpen", "onClose"]),
    (_ctx.showKepMessage)
      ? (_openBlock(), _createBlock(_component_MessagePopup, {
          key: 1,
          message: _ctx.kepMessageText,
          type: "kep",
          position: "top-right",
          duration: 3000,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showKepMessage = false))
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ], 64))
}